import { ErrorPage } from "./Error";

export default ErrorPage